import ValidatingInput from "./ValidatingInput.js";

export default function ErrorForm(formElement) {
    formElement.setAttribute("novalidate", true);
    const inputElement = document.querySelector(".js-error-form-input");
    const inputObject = new ValidatingInput({
        "domElement": inputElement,
        "requiredFlag": true,
        "errorClass": "is-invalid"
    });

    formElement.addEventListener("submit", function(e) {
        const isValid = validate();

        if (!isValid) {
            e.preventDefault();
        }
    });


    function validate() {
        let isValid = true;

        const isInputValid = inputObject.validate();

        if (!isInputValid) {
            isValid = false;
        }

        if (!isValid) {
            formElement.classList.add("not-valid");
        } else {
            formElement.classList.remove("not-valid");
        }

        return isValid;
    }
}